import React, { useEffect, useState } from "react";

import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

function AdminSupportTicket({ adminType }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [data, setData] = useState([]);
  const [noTicket, setNoTicket] = useState(0);
  const [loader, setLoader] = useState(true);
  const [inputData, setInputData] = useState({});
  const [resetPage, setResetPage] = useState(false);
  const [firstRender, setfirstRender] = useState(false);
  const [searchMail, setSearchMail] = useState("");
  const [supportMembers, setsupportMembers] = useState([]);

  // console.log(window.location);
  // console.log(match.url);
  const getTickets = async () => {
    try {
      setfirstRender(true);
      let payload = {};
      // if (adminStore?.admin?.admin?.email == "alex@waqarzaka.net") {
      //   if (inputData?.issueType || firstRender) {
      //     payload = {
      //       ...inputData,
      //       page: page,
      //     };
      //   } else {
      //     payload = {
      //       ...inputData,
      //       page: page,
      //       issueType: "Payment Issue",
      //     };
      //     setInputData(payload);
      //   }
      // } else {
      //   payload = {
      //     page: page,
      //     ...inputData,
      //   };
      // }

      payload = {
        page: page,
        ...inputData,
      };
      setLoader(true);
      const userData = await api.adminAllTicketGet(payload);
      // console.log(userData);
      setData(userData.tickets);
      setNoTicket(userData.count);
      setLimit(userData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (Object.keys(window.location.search).length > 0) {
      if (firstRender) {
        getTickets();
      } else {
        let obj = queryStringToObject(window.location.search);
        // console.log(obj);
        setInputData(obj);
      }
    } else {
      getTickets();
    }
  }, [page, resetPage]);

  const searchFilter = () => {
    if (page == 1) {
      getTickets();
    } else {
      setPage(1);
    }
  };

  const handleReset = () => {
    setInputData({});
    setSearchMail("");
    setResetPage(!resetPage);
    setPage(1);
    navigate("/admin/support");
  };

  const handleSearch = async () => {
    if (searchMail) {
      let payload = {
        email: searchMail,
      };
      const res = await api.adminSearchTicket(payload);
      // console.log(res);
      if (res?.success) {
        setData(res?.tickets);
      } else {
        alert("Invalid Email Address");
      }
    } else {
      alert("Please insert email for search");
    }
  };

  const getSupport = async () => {
    try {
      setLoader(true);
      const res = await api.getSupportAdmin();
      // console.log(res);
      if (res?.success) {
        setsupportMembers(res.support);
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getSupport();
  }, []);

  const queryStringToObject = (url) =>
    Object.fromEntries([...new URLSearchParams(url.split("?")[1])]);

  const objectToQueryString = (dataObject) => {
    let queryString = Object.keys(dataObject)
      .map((key) => {
        if (Array.isArray(dataObject[key])) {
          return dataObject[key]
            .map((item, index) => {
              return (
                encodeURIComponent(key) +
                "[" +
                index +
                "]=" +
                encodeURIComponent(item)
              );
            })
            .join("&");
        } else {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(dataObject[key])
          );
        }
      })
      .join("&");
    return queryString;
  };

  useEffect(() => {
    if (inputData?.status || inputData?.issueType || inputData?.supportId) {
      if (Object.keys(inputData).length > 0) {
        let queryString = objectToQueryString(inputData);
        navigate(`/admin/support?${queryString}`);
      }
      searchFilter();
    }
  }, [inputData]);

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid payHistoryPage">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-12   d-flex justify-content-between pr-0 flex-wrap">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  All Support Tickets ({noTicket})
                </h4>
              </div>
            </div>
            <div className="SupportfilterM row mx-0">
              <div className="col-12">
                <div className="fRow">
                  <div className="me-3">Filter:</div>
                  {/* {adminStore?.admin?.admin?.email != "alex@waqarzaka.net" && (
                                      )} */}

                  <div className="form-group my-3 me-3 position-relative">
                    <i className="fa-solid fa-caret-down  arrowDownIco" />
                    <select
                      name="issueType"
                      id=""
                      onChange={(e) =>
                        setInputData({
                          ...inputData,
                          issueType: e.target.value,
                        })
                      }
                      value={inputData?.issueType}
                      className="form-control ng-dirty ng-invalid ng-touched"
                    >
                      <option value="">Select Issue</option>
                      <option
                        value="Account Issue"
                        selected={
                          inputData?.issueType == "Account Issue" ? true : false
                        }
                      >
                        Account Issue
                      </option>
                      <option
                        value="Payment Issue"
                        selected={
                          inputData?.issueType == "Payment Issue" ? true : false
                        }
                      >
                        Payment Issue
                      </option>
                      <option
                        value="Technical Issue"
                        selected={
                          inputData?.issueType == "Technical Issue"
                            ? true
                            : false
                        }
                      >
                        Technical Issue
                      </option>
                      <option
                        value="Mexc Telegram Group"
                        selected={
                          inputData?.issueType == "Mexc Telegram Group"
                            ? true
                            : false
                        }
                      >
                        Mexc Telegram Group
                      </option>
                      {/* <option
                        value="Boflin Telegram Group"
                        selected={
                          inputData?.issueType == "Boflin Telegram Group"
                            ? true
                            : false
                        }
                      >
                        Boflin Telegram Group
                      </option> */}
                      <option
                        value="Welcome Paid Email Issue"
                        selected={
                          inputData?.issueType == "Welcome Paid Email Issue"
                            ? true
                            : false
                        }
                      >
                        Welcome Paid Email Issue
                      </option>
                      <option
                        value="OTP Issues"
                        selected={
                          inputData?.issueType == "OTP Issues" ? true : false
                        }
                      >
                        OTP Issues
                      </option>
                      <option
                        value="Forgot Password Issues"
                        selected={
                          inputData?.issueType == "Forgot Password Issues"
                            ? true
                            : false
                        }
                      >
                        Forgot Password Issues
                      </option>
                      <option
                        value="Other"
                        selected={
                          inputData?.issueType == "Other" ? true : false
                        }
                      >
                        Other
                      </option>
                    </select>
                  </div>
                  <div className="form-group my-3 me-3 position-relative">
                    <i className="fa-solid fa-caret-down  arrowDownIco" />

                    <select
                      name="status"
                      id=""
                      onChange={(e) =>
                        setInputData({
                          ...inputData,
                          status: e.target.value,
                        })
                      }
                      value={inputData?.status}
                      className="form-control ng-dirty ng-invalid ng-touched"
                    >
                      <option value="">Select Status</option>
                      <option
                        value="pending"
                        selected={inputData?.status == "pending" ? true : false}
                      >
                        Pending
                      </option>
                      <option
                        value="processing"
                        selected={
                          inputData?.status == "processing" ? true : false
                        }
                      >
                        Processing
                      </option>
                      <option
                        value="closed"
                        selected={inputData?.status == "closed" ? true : false}
                      >
                        Closed
                      </option>
                    </select>
                  </div>
                  {(adminStore?.admin?.admin?.email == "alex@waqarzaka.net" ||
                    adminStore?.admin?.admin?.email ==
                      "malaika@waqarzaka.net" ||
                    adminStore?.admin?.admin?.email == "mike@waqarzaka.net" ||
                    adminType == "mackAdmin777") && (
                    <div className="form-group my-3 me-3 position-relative">
                      <i className="fa-solid fa-caret-down  arrowDownIco" />

                      <select
                        name="support"
                        id=""
                        onChange={(e) =>
                          setInputData({
                            ...inputData,
                            supportId: e.target.value,
                          })
                        }
                        value={inputData?.supportId}
                        className="form-control ng-dirty ng-invalid ng-touched"
                      >
                        <option value="">Select Support</option>
                        {supportMembers.map((val, key) => (
                          <option
                            key={key}
                            value={val?._id}
                            selected={
                              inputData?.supportId == val?._id ? true : false
                            }
                          >
                            {val?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="form-group me-4">
                    <div className="searchMadmin form-control p-0 ">
                      <div className="inputM ms-0">
                        <input
                          onChange={(e) => setSearchMail(e.target.value)}
                          type="text"
                          placeholder="Search by email..."
                          value={searchMail}
                        />
                        <i
                          className="fa-solid fa-magnifying-glass"
                          onClick={handleSearch}
                        ></i>
                      </div>
                    </div>
                  </div>
                  <button
                    className="themeBlackBtn"
                    onClick={() => handleReset()}
                  >
                    Reset Filter
                  </button>
                </div>
              </div>
            </div>
            {/* table */}
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noTicket={noTicket}
              limit={limit}
            />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}
const Table = ({ data, page, setPage, noTicket, limit }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const [activeImg, setActiveImg] = useState("");
  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const navigate = useNavigate();
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const handleActiveImg = (link) => {
    setActiveImg(link);
    handleShowMore();
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Issue ID
                  </th>
                  <th scope="col" className="">
                    Image
                  </th>
                  <th scope="col" className="">
                    User Email
                  </th>
                  <th scope="col" className="">
                    Status
                  </th>
                  <th scope="col" className="">
                    Issue Type
                  </th>
                  <th scope="col" className="">
                    Created At
                  </th>
                  <th scope="col" className="">
                    Processed By
                  </th>
                  <th scope="col" className="">
                    Closed By
                  </th>
                  <th scope="col" className="">
                    Expected to close
                  </th>
                  <th scope="col" className="">
                    View
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.issueId}
                      </div>
                    </td>
                    <td>
                      {item?.imageTitle ? (
                        <div
                          className="pImage"
                          style={{ maxWidth: 120, padding: 5 }}
                          onClick={() =>
                            handleActiveImg(
                              `${process.env.REACT_APP_S3URL}/img_${item?.imageTitle}.${item.imageFormat}`
                            )
                          }
                        >
                          <img
                            src={`${process.env.REACT_APP_S3URL}/img_${item?.imageTitle}.${item.imageFormat}`}
                            alt=""
                          />
                        </div>
                      ) : (
                        <div className="text-center">-</div>
                      )}
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.userId?.email}
                      </div>
                    </td>
                    <td scope="row">
                      <div
                        className={
                          item?.status == "pending"
                            ? "red table-text-dark w-max-c db"
                            : item?.status == "processing"
                            ? " yellow table-text-dark w-max-c db"
                            : "green table-text-dark w-max-c db"
                        }
                      >
                        {item?.status}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.issueType}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </span>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.processedBy?.name || "-"}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.closedBy?.name || "-"}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark d-flex jc-center">
                        {/* check ticket message is unread */}
                        {item?.latestUserMessageSeen === false && (
                          <div className="masgNotSeen">
                            <i className="fa-solid fa-message"></i>
                            <span></span>
                          </div>
                        )}
                        {item?.status == "processing" &&
                        item?.processingStartedAt ? (
                          <TicketTimer
                            processingStartedAt={item?.processingStartedAt}
                          />
                        ) : (
                          "-"
                        )}
                      </div>
                    </td>
                    <td>
                      <i
                        className="fa-solid fa-eye cursor-pointer"
                        onClick={() =>
                          navigate(`/admin/support/ticket/${item?.issueId}`)
                        }
                      ></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noTicket / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showMore} onHide={handleCloseMore} centered>
        <Modal.Body>
          <div className="otpModalMain broadcastModal">
            <div className="closeIcon" onClick={handleCloseMore}>
              <i className="fa-solid fa-xmark" />
            </div>

            <div className="showMoreModalM">
              <div className="showMoreModal">
                <img className="w-100" src={activeImg} alt="" />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const TicketTimer = ({ processingStartedAt }) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const startTime = new Date(processingStartedAt).getTime();
      const endTime = startTime + 48 * 60 * 60 * 1000; // 48 hours in ms
      const now = new Date().getTime();
      const remaining = endTime - now;

      if (remaining <= 0) {
        setTimeLeft("Exceeded");
        clearInterval(interval);
        return;
      }

      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
    }, 1000);

    return () => clearInterval(interval);
  }, [processingStartedAt]);

  return (
    <div className="text-sm font-medium text-blue-600 w-max-c">
      {timeLeft ? `${timeLeft}` : "-"}
    </div>
  );
};

export default AdminSupportTicket;
